import React from 'react';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { StaticPage } from '../../components/Views/StaticPage/StaticPage';

const Static = () => <StaticPage />;

Static.getInitialProps = async ({ apolloClient, asPath, req, lng: ctxLng }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData,
    currentLang: ctxLng
  };
};

Static.getLayout = page => (
  <Layout
    isBottomNavigation={true}
    isShowBackButton={false}
    isShowCloseButton={false}
  >
    {page}
  </Layout>
);

export default Static;
